/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Senderror2Inputs */

const en_coinvestments_messages_senderror2 = /** @type {(inputs: Coinvestments_Messages_Senderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send message. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to send message. Please try again." |
*
* @param {Coinvestments_Messages_Senderror2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_senderror2 = /** @type {((inputs?: Coinvestments_Messages_Senderror2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Senderror2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_senderror2(inputs)
});
export { coinvestments_messages_senderror2 as "coInvestments_messages_sendError" }